import { bool, node, string } from 'prop-types'

import { defaultCloseComponent, getModalHeader } from './helpers'

import './ProductFilterModal.scss'

const ProductFilterModal = ({
  title,
  children,
  id,
  titleHasInnerHTML,
  closeComponent,
}) => {
  const titleId = `${id}__Modal__title`

  return (
    <div
      className="m-Modal m-ProductFilterModal"
      id={id}
      aria-hidden="true"
      data-clientside-hook="modal productFilterModal"
    >
      <div
        className="m-Modal__dialog m-Modal__dialog--fullScreen m-ProductFilterModal__dialog"
        role="dialog"
        aria-labelledby={titleId}
      >
        <div
          data-clientside-hook="productFilterModal__header"
          className="m-ProductFilterModal__header u-hidden@medium"
        >
          {getModalHeader({
            titleId,
            title,
            titleHasInnerHTML,
          })}
          <div className="m-ProductFilterModal__close l-flex">
            {closeComponent}
          </div>
        </div>
        <div
          className="m-ProductFilterModal__content u-overflow@small-tiny"
          data-clientside-hook="productFilterModal__content"
        >
          <div className="m-ProductFilterModal__inner">{children}</div>
        </div>
      </div>
    </div>
  )
}

ProductFilterModal.propTypes = {
  children: node.isRequired,
  title: node,
  id: string.isRequired,
  titleHasInnerHTML: bool,
  closeComponent: node,
}

ProductFilterModal.defaultProps = {
  title: null,
  titleHasInnerHTML: false,
  closeComponent: defaultCloseComponent(),
}

export default ProductFilterModal
